
import React from 'react';
import { Button, Col, Form, FormGroup, Input, Label, Modal, ModalHeader, ModalBody, ModalFooter, Row, Spinner } from 'reactstrap';
import JobsList from '../JobsList';
import { common, FilterCollection } from 'plato-js-client';

class JobsListModal extends React.Component {
  constructor(props) {
    super(props);

    this.escFunction = this.escFunction.bind(this);

    this.state = {};
  }

  escFunction(event) {
    if(event.keyCode === 27) {
      //On Esc key reload default data
      this.props.getWorkOrders(...this.props.woTypeAndOrder);
      this.props.toggle();
    }
  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  render() {

    let customHeader = '';

    switch(this.props.woTypeAndOrder[0]){
      case 'Approved':
        customHeader = 'Upcoming jobs';
        break;
      case 'Completed':
        customHeader = this.props.doesNotInvoiceUs ? 'Completed' : 'Jobs with costs to submit';
        break;
      case 'Invoiced':
        customHeader = 'Jobs pending cost approval';
        break;
      case 'Invoice Rejected':
        customHeader = 'Cost rejected jobs';
        break;
      case 'Invoice Approved':
        customHeader = 'Cost accepted jobs';
        break;
      default:
        customHeader ='Jobs';
    }

    return (
      <div>
        <Modal backdrop={'static'} style={{ maxWidth: "900px" }} isOpen={this.props.isOpen} toggle={this.props.toggle} className={this.props.className}>
          <ModalHeader style={{ display: "revert" }} toggle={this.toggle}>
            {customHeader}
            {/* <Row>
              <Col></Col>
              {customHeader === 'Upcoming jobs' && this.props.user.doesnotinvoiceus &&
              <Col xs="auto">

              </Col>
              }
            </Row> */}
          </ModalHeader>
          <ModalBody>
            {this.props.loading && 
              <div style={{ width: "100%",  display: 'flex', justifyContent: "center" }}>
                <Spinner style={{ width: '4rem', height: '4rem', margin: "100px auto" }} color='secondary' />
              </div>
            }
            
            {!this.props.loading && 
              <JobsList 
                dataStatus={this.props.dataStatus}
                woTypeAndOrder={this.props.woTypeAndOrder}
                getWorkOrders={this.props.getWorkOrders}
                keepFilters={this.props.keepFilters}
                extraFilters={this.props.extraFilters}
                resetFiltersAndData={this.props.resetFiltersAndData}
                workOrders={this.props.workOrders}
                properties={this.props.properties}
              />
            }
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.props.loadDefault}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default JobsListModal;


// WEBPACK FOOTER //
// ./src/modals/JobsListModal.js